/* Tootsie filter sheet — stage C swipe-to-dismiss (Ricky spec section 11)
   plus the sort-select width fitter (round 8).
   Drag zone is the handle + header only, never the scrolling list. The sheet
   translates via inline style.transform on .mobile-facets__inner (never a
   custom property, so chips do not restyle per frame). Dismiss = flick
   (velocity > 0.11 px/ms) or distance (> min(35% of sheet, 160px)); the
   canonical close is a click on the wrapper summary, which unlocks body
   scroll through MenuDrawer. With a sub-panel open, drags do nothing — a
   shopper mid-way through picking brands must not lose the sheet.
   facets.js and global.js are untouched. */
(function () {
  var wrapper = document.querySelector('menu-drawer.mobile-facets__wrapper');
  if (!wrapper) return;
  var inner = wrapper.querySelector('.mobile-facets__inner');
  if (!inner) return;

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  var dragging = false;
  var pid = null;
  var startY = 0;
  var startT = 0;
  var dy = 0;

  function clearInline() {
    inner.style.transition = '';
    inner.style.transform = '';
  }

  function onDown(event) {
    if (dragging) return; /* second finger cannot steal a live drag */
    if (!event.isPrimary) return;
    if (window.matchMedia('(min-width: 750px)').matches) return;
    if (wrapper.querySelector('.submenu-open')) return; /* sub-panel open */
    if (event.target.closest('button, a, input, select')) return; /* close button etc. */
    dragging = true;
    pid = event.pointerId;
    startY = event.clientY;
    startT = performance.now();
    dy = 0;
    try {
      event.currentTarget.setPointerCapture(pid);
    } catch (e) {
      /* capture is an optimisation, not a requirement */
    }
    inner.style.transition = 'none';
  }

  function onMove(event) {
    if (!dragging || event.pointerId !== pid) return;
    dy = event.clientY - startY;
    inner.style.transform =
      dy > 0
        ? 'translateY(' + dy + 'px)'
        : 'translateY(' + Math.max(dy * 0.15, -16) + 'px)'; /* upward friction */
  }

  function settleBack() {
    if (reduced.matches) {
      clearInline();
      return;
    }
    inner.style.transition = 'transform 260ms cubic-bezier(0.32, 0.72, 0, 1)';
    inner.style.transform = 'translateY(0)';
    var done = false;
    var finish = function () {
      if (done) return;
      done = true;
      inner.removeEventListener('transitionend', finish);
      clearInline();
    };
    inner.addEventListener('transitionend', finish);
    setTimeout(finish, 350);
  }

  function onUp(event) {
    if (!dragging || event.pointerId !== pid) return;
    dragging = false;
    var dt = Math.max(performance.now() - startT, 1);
    var velocity = dy / dt;
    var sheetH = inner.getBoundingClientRect().height || 1;
    if (dy > 0 && (velocity > 0.11 || dy > Math.min(0.35 * sheetH, 160))) {
      inner.style.transition = 'transform 220ms cubic-bezier(0.32, 0.72, 0, 1)';
      inner.style.transform = 'translateY(105%)';
      var summary = wrapper.querySelector('summary');
      if (summary) summary.click();
      setTimeout(clearInline, 450);
    } else {
      settleBack();
    }
  }

  function onCancel(event) {
    if (!dragging || event.pointerId !== pid) return;
    dragging = false;
    settleBack(); /* a cancelled drag never dismisses */
  }

  var zones = [
    wrapper.querySelector('.mobile-facets__handle'),
    wrapper.querySelector('.mobile-facets__header'),
  ].filter(Boolean);

  zones.forEach(function (zone) {
    zone.addEventListener('pointerdown', onDown);
    zone.addEventListener('pointermove', onMove);
    zone.addEventListener('pointerup', onUp);
    zone.addEventListener('pointercancel', onCancel);
  });

  /* ---- Sort select width fitter (round 8) ----
     The caret must sit immediately after the selected value, but a select
     with width: auto sizes to its WIDEST option, not the selected one — so
     pure CSS leaves the caret detached whenever a shorter option is
     chosen. This measures the selected option's text with the select's own
     font and sets the width to text + paddings (the right padding reserves
     the caret slot). Canvas ignores letter-spacing, and Dawn tracks its
     selects, so it is added back per character, plus a 2px cushion.
     Re-runs on change (delegated — the sort block's innerHTML is replaced
     by facets.js on every AJAX re-render), after webfonts load, and after
     each re-render via a MutationObserver on the sort js-filter block,
     which itself persists. CSS min-width guards the tap target for very
     short options. */
  function fitSortSelect() {
    var sel = document.getElementById('SortBy-mobile');
    if (!sel) return;
    var opt = sel.options[sel.selectedIndex];
    if (!opt) return;
    var cs = getComputedStyle(sel);
    var canvas = fitSortSelect._c || (fitSortSelect._c = document.createElement('canvas'));
    var ctx = canvas.getContext('2d');
    ctx.font = cs.fontWeight + ' ' + cs.fontSize + ' ' + cs.fontFamily;
    var text = opt.textContent.trim();
    var w = ctx.measureText(text).width;
    var ls = parseFloat(cs.letterSpacing);
    if (!isNaN(ls)) w += ls * text.length;
    sel.style.width = Math.ceil(w + parseFloat(cs.paddingLeft) + parseFloat(cs.paddingRight) + 2) + 'px';
  }

  fitSortSelect();
  document.addEventListener('change', function (event) {
    if (event.target && event.target.id === 'SortBy-mobile') fitSortSelect();
  });
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(fitSortSelect);
  var sortBlock = document.querySelector("[id^='Details-Mobile-SortBy']");
  if (sortBlock && window.MutationObserver) {
    new MutationObserver(fitSortSelect).observe(sortBlock, { childList: true, subtree: true });
  }
})();